import { ContentCard } from "@msuite/ui/content-card";
import { icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { Stats } from "@msuite/ui/stats";
import type { ClassNameProps } from "@msuite/ui/types";
import { formatNumber } from "@msuite/utils/numbers";
import type { IncomingInvoiceStatistics } from "@msuite/utils/types";

/** Props Interface */
interface IncomingInvoicesStateTileProps extends ClassNameProps {
	byState: IncomingInvoiceStatistics["byState"];
}

export function IncomingInvoicesStateTile({ className, byState }: IncomingInvoicesStateTileProps) {
	/** Context */
	const { t } = useTranslation();

	/** Render */
	return (
		<ContentCard
			title={t("incoming_invoices.by_state")}
			icon={icon("ChartPie")}
			isCollapsible={false}
			className={className}
			contentClassName="flex-1"
			variant="plain"
		>
			<div className="grid grid-cols-2 grid-rows-2 flex-1 gap-1.5 -mx-2 -mb-2">
				{byState.map((entry) => (
					<div
						key={entry.state}
						className="card rounded-none first:rounded-tl-base last:rounded-br-base nth-2:rounded-tr-base nth-3:rounded-bl-base"
					>
						<Stats.Label>{t(`incoming_invoices.state.${entry.state}`)}</Stats.Label>
						<Stats.Value>{entry.count}</Stats.Value>
						<Stats.Label>{formatNumber(entry.grossAmount, "currency")}</Stats.Label>
					</div>
				))}
			</div>
		</ContentCard>
	);
}
